<template>
	<div id="dContentdetalis">
		<div id="cNav">
			<router-link tag="span" :to="{path:'/Homepage'}">首页</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link tag="span" :to="{path:'/academic/wprotect'}">文物保护</router-link>
			<!--&nbsp;&nbsp;>>&nbsp;&nbsp;
			<span style="clear: both;">{{title}}</span>-->
		</div>
		<div>
		   <div>{{ tableData.title }}</div>
		   <div v-html="tableData.contents">{{ tableData.contents }}</div>
		</div>
		<div style="clear: both;"></div>
	</div>
</template>

<script>
	import qs from 'qs'
	export default{
		data(){
			return{
				clientHeight:'',
				tableData:[],
				infoid:'',
				loading:false,
				title:''
			}
		},
		mounted(){
	      	this.handleSearch()
	    },
		methods:{
			handleSearch(){
		        this.search();
		    },
			// 查询列表
	  		search:function(){
	  			let that = this;
	  			this.loading = true;
	  			this.infoid = this.$route.query.id;
          let url = this.HOST + '/api/v1/protection/protectionOne/'+this.infoid+'';
	  			this.$axios.get(url).then(function(result){
	  				let cData = result.data;
	  				that.title = cData.data.title;
	  				if(cData && cData.data){
	  					that.tableData = cData.data;
	  				}
	  			}).catch(function(error){
	  				console.log(err);
	  			})
	  		}
		}
	}
</script>

<style scoped>
#dContentdetalis{
	width: 80%;
	margin-right: 10%;
	margin-left: 10%;
	height: 100%;
}
#dContentdetalis>#cNav{
	text-align: left;
	height: 48px;
	line-height: 48px;
}
#dContentdetalis>#cNav>span:nth-child(1),
#dContentdetalis>#cNav>span:nth-child(2)
{
	cursor: pointer;
}
#cNav>span:nth-child(1):hover,
#cNav>span:nth-child(2):hover{
	color: #FF9900;
}
#dContentdetalis>div:nth-child(2)>div:nth-child(1){
	line-height: 40px;
	font-size: 1.5em;
	font-weight: 800;
}
#dContentdetalis>div:nth-child(2)>div:nth-child(2){
	text-align: left;
	line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/academic/wprotectDetials.vue